import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Hairdryer = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_128_267)">
        <path
          d="M11.5993 0.1503C11.7189 0.138544 11.8797 0.125 12 0.125C13.0277 0.125 14.0133 0.533258 14.74 1.25996C15.4667 1.98666 15.875 2.97229 15.875 4C15.8743 4.92569 15.5422 5.82083 14.9388 6.52287C14.3879 7.16388 13.6441 7.60548 12.8224 7.78393L10.7962 14.5396C10.7962 14.5396 10.7962 14.5396 10.7962 14.5396C10.715 14.8108 10.5734 15.0601 10.3821 15.2688C10.1907 15.4774 9.95464 15.6401 9.69149 15.7444C9.42833 15.8488 9.14496 15.8923 8.86261 15.8715C8.58027 15.8508 8.30629 15.7664 8.06123 15.6246L8.05389 15.6204C7.68554 15.396 7.40351 15.0541 7.25314 14.6499C7.10324 14.2469 7.09294 13.8053 7.22383 13.3959L8.4868 9.18428C8.5528 8.96437 8.57148 8.73289 8.54154 8.50525C8.51161 8.27761 8.43378 8.0589 8.31318 7.86352C8.19258 7.66815 8.03194 7.50055 7.84186 7.37177C7.65177 7.24299 7.43656 7.15595 7.21039 7.11639L7.20219 7.11496L3.49424 6.38113L0.56165 6.8699C0.452917 6.88802 0.341719 6.85738 0.257609 6.78613C0.1735 6.71488 0.125 6.61023 0.125 6.5V1.5C0.125 1.38977 0.1735 1.28512 0.257609 1.21387C0.341719 1.14262 0.452917 1.11198 0.56165 1.1301L3.49691 1.61931L11.3543 0.178153C11.3614 0.176852 11.3686 0.175755 11.3757 0.174866L11.3808 0.17424L11.394 0.172643L11.4416 0.167081C11.4816 0.162511 11.5371 0.156414 11.5993 0.1503ZM11.4785 0.917888L11.4832 0.917318L11.5268 0.912232C11.5639 0.907989 11.6154 0.902336 11.6727 0.8967C11.7921 0.884956 11.9203 0.875 12 0.875C12.8288 0.875 13.6237 1.20424 14.2097 1.79029C14.7957 2.37627 15.1249 3.17101 15.125 3.9997C15.1244 4.74622 14.8566 5.46787 14.37 6.03403C13.8834 6.6002 13.2103 6.97348 12.4723 7.08631C12.3292 7.1082 12.2114 7.21056 12.1698 7.34927L10.0778 14.3243C10.0291 14.487 9.94407 14.6367 9.82927 14.7619C9.71448 14.8871 9.57282 14.9847 9.41493 15.0473C9.25703 15.1099 9.08701 15.136 8.9176 15.1236C8.74959 15.1112 8.58652 15.0613 8.44042 14.9775C8.21775 14.8408 8.04722 14.6334 7.95608 14.3884C7.86445 14.1421 7.85842 13.8721 7.93896 13.6219L9.20517 9.3998C9.20516 9.39982 9.20518 9.39977 9.20517 9.3998C9.30161 9.07841 9.32889 8.74016 9.28514 8.40748C9.2414 8.07478 9.12765 7.75512 8.95138 7.46957C8.77512 7.18402 8.54034 6.93907 8.26252 6.75085C7.98591 6.56345 7.67288 6.43653 7.3439 6.37836L3.57279 5.63213C3.52847 5.62336 3.48292 5.62267 3.43835 5.6301L0.875 6.05733V1.94267L3.43835 2.3699C3.48119 2.37704 3.52494 2.37668 3.56765 2.36885L11.4785 0.917888Z"
          fill={fill}
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M3.5 1.625C3.70711 1.625 3.875 1.79289 3.875 2V6C3.875 6.20711 3.70711 6.375 3.5 6.375C3.29289 6.375 3.125 6.20711 3.125 6V2C3.125 1.79289 3.29289 1.625 3.5 1.625Z"
          fill={fill}
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          d="M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_128_267">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

Hairdryer.category = 'product-category';

Hairdryer.displayName = 'Hairdryer';
